import { Component, OnInit, AfterViewInit,Input, SimpleChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../core/auth/auth.service';
import { UserService } from '../../../core/user.service';
import * as Chart from "chart.js";
import { bloomAdd } from '@angular/core/src/render3/di';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cqm-ns-analytics',
  templateUrl: './cqm-ns-analytics.component.html',
  styleUrls: ['./cqm-ns-analytics.component.css']
})
export class CqmNsAnalyticsComponent implements OnInit {

  parentMessage = "message from parent"
  projects: any;
  projectId: any;
  application: any;
  hostUrl;
  websiteName: any;
  webSites : any = [];
  webSite: any;
  youGotIDValue: any;
  bindValue: any;
  youGotName: any;
  viewId: any;
  value1: any;
  userId: any;
  constructor(private http: HttpClient, 
    private route: ActivatedRoute,
     private userService: UserService, private authService: AuthService, 
     ) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
    this.hostUrl=this.userService.getUrl();
    this.userId = localStorage.getItem("userid");

   // this.projectId = this.route.snapshot.params["projectId"];
    this.projectId = localStorage.getItem("projectId");
    this.http.get(encodeURI(this.hostUrl+'/api/issue/accountNameGoogleAnalytics/' + this.projectId))
    .subscribe(data => {
      this.application = data;
      this.value1 = this.application[0].View_id;
      // for (let i = 0; i <= this.application.length; i++) {
      // this.webSites.push(this.application[i].View_id);
      // }
    });
  }
  onChange(value1){
  //   this.application.forEach(obj=>{
  //     if(obj['View_id'] == 'value'){
  //      this.youGotIDValue = value
  //      this.youGotName = obj['Name']
  //     }
  //  })
   console.log('value parent',value1)
  }
  
}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-analytics/cqm-ns-analytics.component.ts